import axios from './_nestAxios'

export const getxIdAsEdicion = _id => axios.get(`/partidas/${_id}`)

export const getxIdAsCuenta14 = _id =>
  axios.get(`/partidas/${_id}`, {
    params: {
      tipoConsulta: 'cuenta14'
    }
  })

export const getxSocioAsSelect = idSocio =>
  axios.get('/partidas', { params: { tipoConsulta: 'select', idSocio } })

export const nuevo = data => axios.post('/partidas', data)

export const actualizarxId = (_id, data) => axios.put(`/partidas/${_id}`, data)

export const actualizarEstadoxId = (_id, data) => axios.put(`/partidas/${_id}/estado`, data)

export const eliminarxId = _id => axios.delete(`/partidas/${_id}`)
